import { render, staticRenderFns } from "./LgFinderPageProduto.vue?vue&type=template&id=77a1f5a6"
import script from "./LgFinderPageProduto.vue?vue&type=script&lang=js"
export * from "./LgFinderPageProduto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports